/*
 * EXTERMAL IMPORTS
 */
import React, { Component } from "react";
import { connect } from "react-redux";
import { Dimmer, Loader, Grid, Message, Button, ButtonProps } from "semantic-ui-react";
import classNames from "classnames";
/*
 * CSS IMPORTS
 */
import "../../App.css";
import "../AFrameControlApp.css";
/*
 * INTERNAL LIBRARY AND UTILITY IMPORTS
 */
import * as Constants from "../../utils/Constants";
import { getOperatorMessage } from "../../lib/aframeboxlookup/UtilMethods";
import * as UtilMethods from "../../utils/UtilMethods";
import SharedFunctions from "../../utils/SharedFunctions";


/*
 * INTERNAL COMPONENT IMPORTS
 */
import Login from "../Login/Login";
import ErrorAlert from "../ErrorAlert/ErrorAlert";
import BoxItemList from "../BoxItemList/BoxItemList";
import InfoFooter from "../InfoFooter/InfoFooter";
import WarningList from "../AFrameControlStation/WarningList/WarningList";
import InfoBar from "../InfoBar/InfoBar";
import App from "../../App";
/*
 * ACTION IMPORTS
 */
import { setUser, setWorkstation } from "../../lib/store/reducers/loginInfoReducer";
import {
  clearState,
  clearWarningMessage,
  fetchReviewBox,
  restartBoxDelivery,
  setAction,
  setMissingSortBoxItem,
  setRestartDeliveryModalOpen,
  setReviewBox,
  setShowMissingAmountDialogSortBoxItem,
  setShowVerifyIpackBoxModal,
  setTransitBoxEmpty as setShowPutBackEmptyBox,
  setWarningMessage,
  setWeightError,
  setWrongRxBagScanned,
  toggleScan,
  setBoxReplacementNeeded,
  setBoxReplacementError,
  setIPackBoxBarcode,
} from "../../lib/store/reducers/autostoreModeReducer";
import {
  setAppMode,
  setError,
  clearError,
  setLoadingStatus,
  setLoginStatus,
  setIsBetaWorkstation,
} from "../../lib/store/reducers/applicationStateReducer";
import { ApplicationMode, ApplicationState } from "../../lib/store/types/ApplicationStateTypes";
import { IPayloadWrapper, PayloadWrapper } from "../../lib/store/types/PayloadWrapper";
import { IOperatorInfoModel, OperatorInfoModel } from "../../lib/interfaces/Login/IOperatorInfoModel";
import { IWorkstationInfoModel, WorkstationInfoModel } from "../../lib/interfaces/Login/IWorkstationInfoModel";
import SideBarMenu from "../SideBarMenu/SideBarMenu";
import { ILoginInfo, LoginState } from "../../lib/store/types/LoginStateTypes";
import { LayoutHelperState } from "../../lib/store/types/LayoutHelperState";
import { DispatchType, IAutoStoreControlAppState, ActionStates, IAutoStoreBoxReview, IAutoStoreRestartBoxDeliveryRequest } from "./IAutoStoreControlAppState"
import { IErrorModel } from "../../lib/interfaces/Error/IErrorModel";
import WorkstationEndpoints from "../../lib/workstation/WorkstationEndpoints";
import { setCompanyID } from "../../lib/store/reducers/cartReducer";
import { ISortBoxItemModel } from "../../lib/SortBoxItem/ISortBoxItemModel";
import MissingSkuModalSelectMissing from "../MissingSkuModal/MissingSkuModalSelectMissing";
import MissingSkuModal from "../MissingSkuModal/MissingSkuModal";
import WarningModal from "../WarningModal/WarningModal";
import { ISortBoxModel } from "../../lib/sortbox/ISortBoxModel";
import ConfirmationModal from "../AFrameControlStation/ConfirmationModal/ConfirmationModal";
import SortBoxEndpoints from "../../lib/sortbox/SortBoxEndpoints";
import ArticleWeightModal from "../ArticleWeightModal/ArticleWeightModal";
import SkuEndpoints from "../../lib/sku/SkuEndpoints";
import RestartDeliveryModal from "../BoxReview/components/RestartDeliveryModal/RestartDeliveryModal";
import OperatorConfirmModal from "../OperatorConfirmModal/OperatorConfirmModal";
import { WarningInputModal } from "../WarningInputModal/WarningInputModal";
import Endpoints from "../../lib/autostore/AutoStoreEndpoints";
import MessageClientModal from "../BoxReview/components/BoxValidationMessageComponents/MessageClientModal";
import IPackEndpoints from "../../lib/ipack/IPackEndpoints";
class AutoStoreControlApp extends Component<{
  loginState: LoginState, layout: LayoutHelperState, appState: ApplicationState, autoStoreControlAppState: IAutoStoreControlAppState,
  clearError: () => void,
  setLoginStatus: (status: boolean) => void,
  setUser: (user: IOperatorInfoModel | any) => void,
  setAppMode: (applicationMode: ApplicationMode) => void,
  setWorkstation: (workstationInfo: IWorkstationInfoModel) => void,
  setError: (error: IErrorModel) => void,
  setCompanyID: (companyId: number) => void,
  setIsBetaWorkstation: (enabled: boolean) => void,
  toggleLoading: (enabled: boolean) => void,
  toggleScan: (enabled: boolean) => void,
  fetchReviewBox: (barcode: string, forceTransit: boolean) => void,
  setMissingSortBoxItem: (sortBoxItem: ISortBoxItemModel | null) => void,
  setShowMissingAmountDialogSortBoxItem: (sortBoxItem: ISortBoxItemModel | null) => void,
  setReviewBox: (reviewBox: IAutoStoreBoxReview) => void,
  setWarningMessage: (warningMessage: string) => void,
  clearWarningMessage: () => void,
  setShowVerifyIpackBoxModal: (showModal: boolean) => void,
  setShowPutBackEmptyBox: (isEmpty: boolean) => void,
  setWeightError: (weightError: string) => void,
  setRestartDeliveryModalOpen: (modalOpen: boolean) => void,
  restartBoxDelivery: (request: IAutoStoreRestartBoxDeliveryRequest) => void,
  setWrongRxBagScanned: (wrongScanned: boolean) => void,
  setBoxReplacementNeeded: (boxReplacementNeeded: boolean) => void,
  setBoxReplacementError: (boxReplacementError: string | null) => void,
  setIPackBoxBarcode: (newBoxBarcode: string) => void,
}, {}>{
  private _inputRef: React.RefObject<HTMLInputElement>;
  constructor(props: any) {
    super(props);
    this._inputRef = React.createRef();
  }

  componentDidMount() {
    this._setInputFocus();
  }
  comonentDidUpdate() {
    const { showVerifyIPackBoxBarcodeModal } = this.props.autoStoreControlAppState;
    if (!showVerifyIPackBoxBarcodeModal) this._setInputFocus();
    else this._clearInputFocus();
  }

  _loginCallback = async (operator: any) => { //TODO operator:ILoginInfo 
    this.props.clearError();
    await this._setWorkstationID();
    this.props.setAppMode(ApplicationMode.AutoStoreReviewMode);
    this.props.setUser(new OperatorInfoModel(operator.operatorId, operator.operatorName));
    this.props.setLoginStatus(true);
  }

  _clearInputFocus() {
    if (this._inputRef && this._inputRef.current) {
      this._inputRef.current.onblur = function () { }
    }
  }

  _setInputFocus() {
    if (this._inputRef && this._inputRef.current) {
      this._inputRef.current.focus();
      this._inputRef.current.onblur = function () { document?.getElementById("ScanInputField")?.focus() }
    }
  }

  async _setWorkstationID() {
    return await new Promise<void>((resolve, reject) => {
      let workstationID = UtilMethods.getParamValue("ws");

      var rejectWrap = (e: IErrorModel) => {
        this._addError(e);
        reject();
      };

      WorkstationEndpoints.getWorkstationInformation(workstationID)
        .then((wsResult: any) => {
          var wsType = wsResult.workstationType;
          let isBetaWorkstation = document.location.href.includes("preprod");
          if (wsType != Constants.WorkstationTypes.AutostoreAutomation) {
            this._addError({
              errorType: -1,
              message: "Felaktig arbetsstation!",
              visible: true
            });
            return
          }
          this.props.setWorkstation(new WorkstationInfoModel(workstationID,
            wsType,
            wsResult.branchID,
            wsResult.autoScaleEnabled));
          this.props.setIsBetaWorkstation(isBetaWorkstation);
          this.props.setCompanyID(Constants.PackagingTypes.Apotea);
          return resolve();
        })
        .catch(rejectWrap);
    });
  }
  _completeFinalizeOrder = (isTransitBox: boolean, iPackBarcode: string) => {
    this.props.setShowVerifyIpackBoxModal(false);
    if (isTransitBox) this.props.fetchReviewBox(iPackBarcode!!, true)
    else if (!this.props.autoStoreControlAppState.boxReview?.sortBoxModel.sortBoxItems.some(x=> x.skuID > Constants.RX_BAG_SKU))
    this.props.fetchReviewBox(iPackBarcode!!, false) //re-fetch review-box if no rx-bag exists as all rx-items are reset in backend
  };


  _skuIsMissing(skuID: number, shelfNumber: string, sortBoxItem: ISortBoxItemModel | null) {
    var boxItem: ISortBoxItemModel
    const {
      sortBoxModel,
    } = this.props.autoStoreControlAppState.boxReview as IAutoStoreBoxReview ?? {};
    if (sortBoxItem) {
      boxItem = sortBoxItem;
    } else {
      boxItem = SharedFunctions.mergeItems("skuID", sortBoxModel?.sortBoxItems).find(
        (bi: { skuID: number; shelfNumber: string; }) => bi.skuID === skuID && bi.shelfNumber === shelfNumber
      );
    }
    this.props.setShowMissingAmountDialogSortBoxItem(boxItem);
  }


  _onInputKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key !== "Enter") {
      return;
    }

    const target = e.target as HTMLInputElement;

    const {
      sortBoxModel,
      boxIsFinalized,
      isAframeFinalized
    } = this.props.autoStoreControlAppState.boxReview as IAutoStoreBoxReview ?? {};
    if (this.props.autoStoreControlAppState.action === ActionStates.COMPLETE_BOX &&
      (sortBoxModel?.sortBoxItems?.some(x => x.verifiedQuantity < x.reservedQuantity))) {
      this._handleSkuInput(target.value, sortBoxModel, "input", boxIsFinalized || isAframeFinalized);
      target.value = "";
    }
    else
      this._submitInput(target);
  };

  _submitInput = (targetRef: HTMLInputElement) => {
    let input = targetRef.value.trim().toUpperCase();
    this._loadBox(input);

    targetRef.value = "";
  };

  _isRXBagEAN(input: string) {
    ////console.log("Scanned " + input + scanInputType)
    let isRXBag = false;
    let rxEAN = input.slice(0, 5);

    if (parseInt(rxEAN) === 39907) {
      isRXBag = true;
    }
    return isRXBag;
  }

  _handleSkuInput(input: string, sortBoxModel: ISortBoxModel, origin: string, boxIsFinalized: Boolean) {
    var currentBoxItem: ISortBoxItemModel;
    if (origin === "click") {
      try {
        let skuID = parseInt(input.split("K")[1]);
        if (skuID > Constants.RX_BAG_SKU) {
          this.props.setWarningMessage("RX-påse måste skannas!");
          return;
        } else {
          currentBoxItem = sortBoxModel.sortBoxItems.filter(x => x.skuID === skuID && x.verifiedQuantity < x.reservedQuantity)[0];
        }
      } catch (e) {
        return;
      }
    } else {
      let isRXBag = this._isRXBagEAN(input);
      if (isRXBag) {
        SharedFunctions.LogScannedRXBag(input);
      }
      let matchingItems = sortBoxModel.sortBoxItems.filter(x => x.eans.includes(input.trim()) && x.verifiedQuantity < x.reservedQuantity);
      if (matchingItems.length === 0) {
        console.log("No matching boxitem found for input:" + input);
        if (isRXBag) {
          this.props.setWrongRxBagScanned(true);
        } else {
          this.props.setWarningMessage("Artikeln finns inte på ordern");
        }
        return;
      }
      currentBoxItem = matchingItems[0];
    }
    if (currentBoxItem.verifiedQuantity < currentBoxItem.reservedQuantity) {
      const { isTransitBox } = this.props.autoStoreControlAppState.boxReview as IAutoStoreBoxReview ?? {};
      const { iPackBoxBarcode } = this.props.autoStoreControlAppState;
      currentBoxItem.verifiedQuantity++;
      currentBoxItem.partialQuantity++;
      this.props.setReviewBox(this.props.autoStoreControlAppState.boxReview as IAutoStoreBoxReview);
      if (!sortBoxModel.sortBoxItems.some(x => x.verifiedQuantity < x.reservedQuantity)) {
        if (!boxIsFinalized) this._finalizeSortBox(this.props.autoStoreControlAppState.boxReview, iPackBoxBarcode, isTransitBox)
        else this.props.setShowVerifyIpackBoxModal(true);
      }
    }
  }

  _addError(error: IErrorModel) {
    this.props.setError({
      message: error.message,
      visible: true,
      errorType: -1,
    });
    this._setInputFocus();
    this.props.toggleLoading(false);
  }


  _loadBox = (input: string) => {
    this.props.clearError();
    this.props.fetchReviewBox(input, false);
  };

  _signOut = () => {
    this.props.setLoginStatus(false);
  };

  _updateBoxItemsState(skuID: number) {
    const { sortBoxModel } = this.props.autoStoreControlAppState.boxReview as IAutoStoreBoxReview ?? {}
    var updateBoxitems = sortBoxModel?.sortBoxItems;
    updateBoxitems?.forEach((bi) => {
      if (bi.skuID === skuID) {
        bi.requireWeighing = false;
      }
    });
  }

  _setWeightOnSku(skuID: number | null | undefined, weight: number | null | undefined, ref: any) {
    if (skuID && weight) {
      return SkuEndpoints.setWeightOnSku(skuID, weight).then((result: boolean) => {
        if (result == true) {
          this.props.setWeightError('');
          this._updateBoxItemsState(skuID);
        } else {
          this.props.setWeightError('Felaktig vikt angiven');
        }
      });
    }
  }

  _measurementCallback = (skuID: number | null | undefined) => {
    if (skuID && skuID !== -1) {
      this._updateBoxItemsState(skuID);
    }
  }


  _finalizeSortBox(reviewBox: IAutoStoreBoxReview | null, iPackBarcode: string | null, isTransitBox: boolean) {
    if (!iPackBarcode || !reviewBox || reviewBox.isAframeFinalized || reviewBox.boxIsFinalized) return;
    reviewBox.boxIsFinalized = true;
    this._clearInputFocus();
    if (isTransitBox) {
      this.props.setShowVerifyIpackBoxModal(true);
      return;
    }
    this.props.setReviewBox(reviewBox);
    this.props.toggleLoading(true);
    let scannedItems = reviewBox.sortBoxModel.sortBoxItems.filter((bi) => bi.verifiedQuantity > 0);
    SortBoxEndpoints.finalizeSortboxNoCatch(
      reviewBox.sortBoxModel.sortBoxID,
      iPackBarcode,
      [],
      false,
      scannedItems
    )
    .then((result) => {
      if (result?.status === 409) {
        this.props.setBoxReplacementNeeded(true);
      }else if (!result?.ok){
        var error = { message: "Fel vid anslutning till server." };
        throw error;
      }else if (result?.ok) {
        this.props.setShowVerifyIpackBoxModal(true);
        this.props.setBoxReplacementNeeded(false);
      }
    }).then(async () =>
       await IPackEndpoints.sendASPackageForNoValidation(iPackBarcode)
      ).catch((e) => {
      reviewBox.boxIsFinalized = false;
      this.props.setReviewBox(reviewBox);
      const errorMessage = e.exceptionMessage ?? "Något gick fel vid utleverans.";
      this._addError({
        errorType: -1,
        message: errorMessage,
        visible: true
      });
      reviewBox.sortBoxModel.sortBoxItems.forEach(x => x.verifiedQuantity = 0);
      console.log(e);
    }).finally(() => {
      this.props.toggleLoading(false);
    })
  }


  render() {
    let classes = classNames({
      aFrameControlApp: this.props.autoStoreControlAppState.action === ActionStates.LOAD_BOX,
      aFrameControlAppInitialMode: this.props.autoStoreControlAppState.boxReview === undefined,
    });

    if (!this.props.loginState.operatorID || this.props.loginState.operatorID === -1) {
      return (
        <React.Fragment>
          <Login
            loginCallback={(operator: ILoginInfo) => this._loginCallback(operator)}
            workstationID={UtilMethods.getParamValue("ws")}
            loginView={Constants.VIEW.AUTOSTORE}
          />
          <ErrorAlert error={""} />
        </React.Fragment>
      );
    }

    const { loading } = this.props.appState;
    const {
      sortBoxModel,
      orderWarnings,
      orderShippingMethod,
      orderLatestShippingTime,
      boxIsFinalized,
      destinationTransitShelf,
      isTransitBox,
      isAframeFinalized,
      isAframeBox
    } = this.props.autoStoreControlAppState.boxReview as IAutoStoreBoxReview ?? {};
    const {
      missingSortBoxItem,
      showMissingAmountDialogSortBoxItem,
      warningMessage, showVerifyIPackBoxBarcodeModal, iPackBoxBarcode, isEmptyTransitBox, weightError,
      wrongRXBagScanned, boxReplacementNeeded, boxReplacementError} = this.props.autoStoreControlAppState;

    const { autoScaleEnabled } = this.props.loginState;


    let classes2 = classNames({
      aFrameControlStationTypeInfo: true,
      large: true,
    });
    if (!showVerifyIPackBoxBarcodeModal && !showMissingAmountDialogSortBoxItem && missingSortBoxItem == null && boxReplacementNeeded == false) this._setInputFocus();
    else this._clearInputFocus();
    let showMissingButton = sortBoxModel?.sortBoxItems != null && sortBoxModel?.sortBoxItems.some(x => x.verifiedQuantity != x.reservedQuantity);

    const { operatorName } = this.props.loginState;
    return (
      <div className={classes}>
      <MessageClientModal/>
        <Dimmer active={loading} inverted>
          <Loader size="big" />
        </Dimmer>
        <SideBarMenu logOut={() => this._signOut()}
          restartDelivery={(boxIsFinalized && !isTransitBox && sortBoxModel?.sortBoxItems != null && sortBoxModel.sortBoxItems.length > 0) ? () => this.props.setRestartDeliveryModalOpen(true) : null}
        ></SideBarMenu>
        {sortBoxModel?.sortBoxID === undefined ? (
          <Message size="massive" info className={classes2}>
            Kontrollstation - AutoStore
          </Message>
        ) : null}
        <Grid columns={2} className="GridContainer">
          <Grid.Column className="articleColumn" width={12}>
            <BoxItemList
              aframe={true}
              skuChannels={[]}
              skuInputCallback={(input: string, _: number, origin: string) => this._handleSkuInput(input, sortBoxModel, origin, boxIsFinalized || isAframeFinalized)}
              boxItems={SharedFunctions.mergeItems("skuID", sortBoxModel?.sortBoxItems) ?? []}
              isLoading={loading}
              isWaitingForBox={false}
              skuIsMissingCallback={(showMissingButton) ? ((skuID: number, shelfNumber: string, sortBoxItem: ISortBoxItemModel) => { this._skuIsMissing(skuID, shelfNumber, sortBoxItem); }) : null}
              isSingle={undefined}
              isPaused={undefined}
              isAuto={undefined}
              isUrgent={undefined}
              alwaysShowMissing={(showMissingButton && !sortBoxModel?.sortBoxItems.some(x => x.skuID  )) ? true : false}
            ></BoxItemList>
          </Grid.Column>
          <Grid.Column className="flexColumn" width={4}>
            <InfoBar
              isAuto={true}
              operatorInstruction={(boxIsFinalized && !sortBoxModel?.sortBoxItems.some(x => x.verifiedQuantity != x.reservedQuantity)) ? ((isTransitBox) ? "TRANSITLÅDA HANTERAD" : "ORDER LEVERERAD") : (isTransitBox) ? "KONTROLLERA TRANSITORDER" : getOperatorMessage(this.props.autoStoreControlAppState.action)}
              nextAction={null}
              currentOrderNumber={sortBoxModel?.orderNumber ?? -1}
              fromAFrameControl={true}
              sortID={sortBoxModel?.sortID ?? -1}
              shippingMethod={orderShippingMethod}
              latestShipping={orderLatestShippingTime}
              aFrameControlStation={10}
            ></InfoBar>
            {isTransitBox && boxIsFinalized && !sortBoxModel?.sortBoxItems.some(x => x.verifiedQuantity != x.reservedQuantity) && sortBoxModel?.sortBoxItems.length > 0 ? (
              <Message size="massive" className={classes} info>
                <b>TRANSITHYLLA {destinationTransitShelf}</b>
              </Message>) : null}
            <WarningList
              infoBarHeight={this.props.layout.height}
              hasWarnings={orderWarnings?.length > 0 ?? false}
              warnings={orderWarnings ?? []}
              boxID={sortBoxModel?.sortBoxID ?? -1}
              orderChecked={false}
              orderCompletition={undefined}
            ></WarningList>
          </Grid.Column>
        </Grid>
        {!!missingSortBoxItem ? (
          <MissingSkuModal
            open={!!missingSortBoxItem}
            fromReview={false}
            removeSkuAccess={false}
            currentOrderNumber={sortBoxModel.orderNumber}
            boxItem={missingSortBoxItem}
            foundSkuCallback={(newSortBoxItems: ISortBoxItemModel[]) => {
              newSortBoxItems = SharedFunctions.getUpdatedBoxItems(newSortBoxItems, sortBoxModel?.sortBoxItems)
              const newSortBoxModel = { ...sortBoxModel, sortBoxItems: newSortBoxItems };
              var reviewBox = this.props.autoStoreControlAppState.boxReview;
              const newReviewBox = { ...reviewBox, sortBoxModel: newSortBoxModel } as IAutoStoreBoxReview;
              this.props.setReviewBox(newReviewBox);
              if (newSortBoxItems.length == 0){
                if (isTransitBox || !isAframeBox ) this.props.setShowPutBackEmptyBox(true);
                else if (isAframeBox && !isAframeFinalized) this._finalizeSortBox(newReviewBox, iPackBoxBarcode,false) //finalize aframe box
              }else if (!newSortBoxItems?.some(x => x.verifiedQuantity < x.reservedQuantity)){
                if (!isAframeBox || (isAframeBox && !isAframeFinalized)) this._finalizeSortBox(newReviewBox, iPackBoxBarcode,isTransitBox);
              } 
            }}
            onClose={() => { this.props.setMissingSortBoxItem(null); }}
            cartNumber={null}
            isScanIdValidationRemoveSkuRequired={
              this.props.appState.isScanIdValidationRemoveSkuRequired
            }
            partialDelivery={false}
            loginState={this.props.loginState}
            isTransitBox={isTransitBox}
          />
        ) : null}
        {!!showMissingAmountDialogSortBoxItem ? (
          <MissingSkuModalSelectMissing onCloseClearState={() => {
            this.props.setShowMissingAmountDialogSortBoxItem(null);
          }}
            boxItem={showMissingAmountDialogSortBoxItem} missingSkuSetVerifiedQuantity={(missingAmount: number | null, boxItem: ISortBoxItemModel) => {
              const { sortBoxModel } = this.props.autoStoreControlAppState.boxReview as IAutoStoreBoxReview ?? {};
              if (!missingAmount || sortBoxModel.sortBoxID != boxItem.boxID)
                return;
              var missingBoxItem = SharedFunctions.mergeItems("skuID", sortBoxModel?.sortBoxItems).find(
                (bi: { skuID: number; shelfNumber: string; }) => bi.skuID === boxItem.skuID && bi.shelfNumber === boxItem.shelfNumber
              );
              missingBoxItem.verifiedQuantity = boxItem.reservedQuantity - missingAmount;
              this.props.setShowMissingAmountDialogSortBoxItem(null);
              this.props.setMissingSortBoxItem(missingBoxItem);
            }} reservedQuantityIsMaxMissing={true} />
        ) : null}
        {warningMessage ? (
          <WarningModal
            open={true}
            onClose={(_: any) => this.props.clearWarningMessage()}
            message={warningMessage}
            header={"Felaktig scan"}
            cssClass={""}
            autoClose={false}
            isCartInstruction={false}
            workstationID={this.props.loginState.workstationID}
            cartSuggestion={undefined}
            changeCartSuggestion={undefined}
            acceptCart={undefined}
            closeButtonText={null}
            errorCode={110}
          />
        ) : null}
        {boxReplacementNeeded ? (
          <WarningInputModal
            open={true}
            onClose={(cancel: boolean, comment: string) => {
              if (!cancel){
                this.props.setBoxReplacementError(null);
                Endpoints.replaceBox(sortBoxModel.sortBoxID, comment).then(result=> {
                  this._finalizeSortBox(this.props.autoStoreControlAppState.boxReview, iPackBoxBarcode,isTransitBox);
                  this.props.setIPackBoxBarcode(comment);
                }).catch(error=> {
                  const errorMessage = error.message ?? "Något gick fel vid byte av låda, försök igen.";
                  this.props.setBoxReplacementError(errorMessage);
                  console.log(error);
                });
              }
            }}
            header={"Lådan måste bytas ut, scanna ny låda"}
            needConfirmation={false}
            errorMessage={boxReplacementError}
          ></WarningInputModal>
        ) : null}
        {showVerifyIPackBoxBarcodeModal ? (
          <ConfirmationModal
            open={true}
            callback={() => this._completeFinalizeOrder(isTransitBox, iPackBoxBarcode!!)}
            iPackBoxBarcode={iPackBoxBarcode}
          ></ConfirmationModal>
        ) : null}
        {(!boxIsFinalized && (destinationTransitShelf || isEmptyTransitBox)) || 
        (boxIsFinalized && isAframeFinalized && (sortBoxModel?.sortBoxItems == null || sortBoxModel?.sortBoxItems.length == 0)) ? (
          <WarningModal
            open={true}
            onClose={(_: String) => {
              this.props.setShowPutBackEmptyBox(false);
              this.props.setReviewBox({
                sortBoxModel: sortBoxModel,
                orderWarnings: [],
                orderShippingMethod: orderShippingMethod,
                orderLatestShippingTime: orderLatestShippingTime,
                destinationTransitShelf: destinationTransitShelf,
                boxIsFinalized: true,
                isTransitBox: isTransitBox,
                isAutoStoreFinished: true,
                isAframeFinalized: false,
                isAframeBox: isAframeBox
              });
            }}
            message={
              (!boxIsFinalized && (destinationTransitShelf || isEmptyTransitBox)) ?
                (isEmptyTransitBox) ? "Lägg tillbaka lådan på samlingsplats" : ("Flytta innehållet till hyllplats " + destinationTransitShelf)
                : "Lägg tomma lådan på banan för aframe-plock"
            }
            header={"Hänvisning"}
            cssClass={"warning-modal-instruction"}
            autoClose={false}
            isCartInstruction={false}
            workstationID={this.props.loginState.workstationID}
            cartSuggestion={null}
            changeCartSuggestion={null}
            acceptCart={null}
            closeButtonText={"OK"}
            errorCode={110}
          />
        ) : null}
        {wrongRXBagScanned ? (
          <OperatorConfirmModal
            open={true}
            onClose={() => {
              var reviewBox = this.props.autoStoreControlAppState.boxReview;
              reviewBox?.sortBoxModel.sortBoxItems.forEach(x => x.verifiedQuantity = 0);
              if (reviewBox) {
                this.props.setReviewBox(reviewBox);
                this.props.setWrongRxBagScanned(false);
                this.props.setWarningMessage("Skanna varorna igen.");
              }
            }
            }
            SortBoxID={sortBoxModel?.sortBoxID}
            orderNumber={sortBoxModel?.orderNumber}
            isScanIdValidationRxRequired={this.props.appState.isScanIdValidationRxRequired}
          />
        ) : null}
        <ErrorAlert error={this.props.appState.errorMessage} />
        <ArticleWeightModal
          scannedSKU={sortBoxModel?.sortBoxItems?.find(z => z.requireWeighing)?.skuID ?? -1}
          boxItems={sortBoxModel?.sortBoxItems}
          getWeight={(skuID: number | null | undefined) => (skuID) ? SkuEndpoints.getWeightSku(skuID) : null}
          setWeight={(skuID: number | null | undefined, weight: number | null | undefined) => { return this._setWeightOnSku(skuID, weight, this) }}
          autoScaleEnabled={autoScaleEnabled}
          cartShelfID={sortBoxModel?.shelfNumber?.toString() ?? ""}
          callback={this._measurementCallback}
          weightError={weightError} />
        <InfoFooter
          operatorName={operatorName}
          isApoteaPackaging={true}
          sortID={sortBoxModel?.sortID}
          orderNumber={sortBoxModel?.orderNumber}
          cartID={undefined}
          cartShelf={undefined}
          workstationID={undefined}
          companyID={undefined}
          pendingInstruction={undefined}
          boxID={undefined}
          cartLocationHistory={undefined} />
        {boxIsFinalized ? (
          <RestartDeliveryModal
            open={this.props.autoStoreControlAppState.restartDeliveryModalOpen}
            continueCallback={() => {
              this.props.restartBoxDelivery({
                barcode: iPackBoxBarcode!!,
                invoiceNumber: this.props.autoStoreControlAppState.boxReview?.sortBoxModel.invoiceNumber!!
              })
            }} //this._restartDelivery
            cancelCallback={() => this.props.setRestartDeliveryModalOpen(false)}
          />
        ) : null}
        <input
          className="ScanInputField"
          autoComplete="off"
          id="ScanInputField"
          autoFocus
          onKeyPress={(e) => this._onInputKeyPress(e)}
          ref={this._inputRef}
          disabled={this.props.autoStoreControlAppState.scanDisabled}
        />
      </div>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    autoStoreControlAppState: state.autostoreModeReducer as IAutoStoreControlAppState,
    loginState: state.loginInfoReducer as LoginState,
    layout: state.layoutHelperReducer as LayoutHelperState,
    appState: state.applicationStateReducer as ApplicationState,
  };
};

const mapDispatchToProps = (dispatch: DispatchType) => {
  return {
    setAppMode: (mode: ApplicationMode) => dispatch(setAppMode(new PayloadWrapper(mode))),
    toggleLoading: (loading: boolean) => dispatch(setLoadingStatus(new PayloadWrapper(loading))),
    clearError: () => dispatch(clearError()),
    setWorkstation: (workstationInfo: IWorkstationInfoModel) =>
      dispatch(setWorkstation(workstationInfo)),
    setUser: (user: IOperatorInfoModel) =>
      dispatch(setUser(user)),
    setError: (error: IErrorModel) => dispatch(setError(error)),
    setLoginStatus: (status: boolean) =>
      dispatch(setLoginStatus(new PayloadWrapper(status))),
    setIsBetaWorkstation: (beta: boolean) => dispatch(setIsBetaWorkstation(new PayloadWrapper(beta))),
    clearReviewBoxModel: () => dispatch(clearState()),
    setAction: (action: ActionStates) => dispatch(setAction(new PayloadWrapper(action))),
    fetchReviewBox: (barcode: string, forceTransit: boolean) => dispatch(fetchReviewBox(new PayloadWrapper({ barcode: barcode, forceTransit: forceTransit }))),
    toggleScan: (value: boolean) => dispatch(toggleScan(new PayloadWrapper(value))),
    setCompanyID: (companyID: number) => dispatch(setCompanyID(new PayloadWrapper(companyID))),
    setMissingSortBoxItem: (sortBoxItem: ISortBoxItemModel | null) => dispatch(setMissingSortBoxItem(new PayloadWrapper(sortBoxItem))),
    setShowMissingAmountDialogSortBoxItem: (sortBoxItem: ISortBoxItemModel | null) => dispatch(setShowMissingAmountDialogSortBoxItem(new PayloadWrapper(sortBoxItem))),
    setReviewBox: (reviewBox: IAutoStoreBoxReview) => dispatch(setReviewBox(new PayloadWrapper(reviewBox))),
    setWarningMessage: (warningMessage: string) => dispatch(setWarningMessage(new PayloadWrapper(warningMessage))),
    clearWarningMessage: () => dispatch(clearWarningMessage()),
    setShowVerifyIpackBoxModal: (showModal: boolean) => dispatch(setShowVerifyIpackBoxModal(new PayloadWrapper(showModal))),
    setShowPutBackEmptyBox: (isEmpty: boolean) => dispatch(setShowPutBackEmptyBox(new PayloadWrapper(isEmpty))),
    setWeightError: (weightError: string) => dispatch(setWeightError(new PayloadWrapper(weightError))),
    setRestartDeliveryModalOpen: (modalOpen: boolean) => dispatch(setRestartDeliveryModalOpen(new PayloadWrapper(modalOpen))),
    restartBoxDelivery: (restartDeliveryRequest: IAutoStoreRestartBoxDeliveryRequest) => dispatch(restartBoxDelivery(new PayloadWrapper(restartDeliveryRequest))),
    setWrongRxBagScanned: (wrongScanned: boolean) => dispatch(setWrongRxBagScanned(new PayloadWrapper(wrongScanned))),
    setBoxReplacementNeeded: (boxReplacementNeeded: boolean) => dispatch(setBoxReplacementNeeded(new PayloadWrapper(boxReplacementNeeded))),
    setBoxReplacementError: (boxReplacementError: string | null) => dispatch(setBoxReplacementError(new PayloadWrapper(boxReplacementError))),
    setIPackBoxBarcode: (newBoxBarcode: string) => dispatch(setIPackBoxBarcode(new PayloadWrapper(newBoxBarcode))),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AutoStoreControlApp);
